import { render, staticRenderFns } from "./Borradores.vue?vue&type=template&id=6934eb90"
import script from "./Borradores.vue?vue&type=script&lang=js"
export * from "./Borradores.vue?vue&type=script&lang=js"
import style0 from "./Borradores.vue?vue&type=style&index=0&id=6934eb90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports